
export enum Services {
  ISSUES = 'issues',
  COMPANIES = 'companies',
  CONTRACTS = 'contracts',
  PROJECTS = 'projects',
  USERS = 'users',
  ORGANIZATIONS = 'organizations',
  INSPECTION_TEMPLATES = 'inspectionTemplates',
  INSPECTIONS = 'inspections',
  DOCUMENTS = 'documents',
  SITES = 'sites',
  WORKTYPES = 'worktypes',
  HAZARD_CATEGORIES = 'hazardCategories',
  ENVIRONMENTAL_ASPECTS = 'environmentalAspects',
  CORRECTIVE_ACTION_TYPES = 'correctiveActionTypes',
  DELAY_REASONS = 'delayReasons',
  ISSUE_VERIFICATION_ITEMS = 'issueVerificationItems',
  REJECTION_REASONS = 'rejectionReasons',
  ROOT_CAUSES = 'rootCauses',
  EFFECTS = 'effects',
  CIRCUMSTANCES = 'circumstances',
  IMPACTS = 'impacts',
  DECISIONS_TO_IMPOSE_FINE = 'decisionsToImposeFine',
  SPILLED_SUBSTANCES = 'spilledSubstances',
  LEVELS = 'levels',
  DOCUMENTATIONS = 'documentations',
  DIRECTORIES = 'directories',
  ISSUE_FORMS = 'issueForms',
  ISSUE_WORKFLOWS = 'issueWorkflows',
  PROCESSES = 'processes',
  VISIBLE_FIELDS = 'visibleFields',
  PRIORITIES = 'priorities',
  PROJECT_STAGES = 'projectStages',
  EMPLOYMENT_TYPES = 'employmentTypes',
  INJURY_TYPES = 'injuryTypes',
  INJURED_BODY_PARTS = 'injuredBodyParts',
  REQUIREMENTS = 'requirements',
  INSTALLATION_BASIS = 'installationBasis',
  CONSTRUCTION_PRODUCT_DOCUMENTS = 'constructionProductDocuments',
  DEVICE_DOCUMENTS = 'deviceDocuments',
  ADDITIONAL_DOCUMENTS = 'additionalDocuments',
}

export enum DomainMessagesTypes {
  sessionRestored = 'sessionRestored',

  allIssues = 'allIssues',


  logout = 'logout',
  projectDataFlushed = 'projectDataFlushed',

  /** A pull of an entity failed (non-abort); payload in `error`, no `data`. */
  pullFailed = 'pullFailed',

  allCompanies = 'allCompanies',

  allContracts = 'allContracts',

  clearData = 'clearData',
  dataFlushed = 'dataFlushed',

  allUsers = 'allUsers',



  allProjects = 'allProjects',

  selectedProject = 'selectedProject',

  allOrganizations = 'allOrganizations',


  allInspectionTemplates = 'allInspectionTemplates',

  createdEntity = 'createdEntity',
  updatedEntity = 'updatedEntity',
  deletedEntity = 'deletedEntity',
  uploadedEntity = 'uploadedEntity',
  failUploadedEntity = 'failUploadedEntity',

  allInspections = 'allInspections',


  createdDrawing = 'createdDrawing',

  allSites = 'allSites',


  allWorktypes = 'allWorktypes',

  allHazardCategories = 'allHazardCategories',

  allEnvironmentalAspects = 'allEnvironmentalAspects',

  allCorrectiveActionTypes = 'allCorrectiveActionTypes',

  allDelayReasons = 'allDelayReasons',

  allIssueVerificationItems = 'allIssueVerificationItems',

  allRejectionReasons = 'allRejectionReasons',

  allRootCauses = 'allRootCauses',

  allEffects = 'allEffects',

  allCircumstances = 'allCircumstances',

  allImpacts = 'allImpacts',

  allDecisionsToImposeFine = 'allDecisionsToImposeFine',

  allSpilledSubstances = 'allSpilledSubstances',

  allPriorities = 'allPriorities',

  allProjectStages = 'allProjectStages',

  allEmploymentTypes = 'allEmploymentTypes',

  allInjuryTypes = 'allInjuryTypes',

  allInjuredBodyParts = 'allInjuredBodyParts',

  allRequirements = 'allRequirements',

  allInstallationBasis = 'allInstallationBasis',

  allConstructionProductDocuments = 'allConstructionProductDocuments',

  allDeviceDocuments = 'allDeviceDocuments',

  allAdditionalDocuments = 'allAdditionalDocuments',

  allLevels = 'allLevels',
  allDocumentations = 'allDocumentations',
  allDirectories = 'allDirectories',
  directoriesBatchCreated = 'directoriesBatchCreated',

  documentationMoved = 'documentationMoved',
  documentationDeleted = 'documentationDeleted',
  documentationRestored = 'documentationRestored',

  tableChanged = 'tableChanged',

  currentUserPermissions = 'currentUserPermissions',

  apiVersionMismatch = 'apiVersionMismatch',

  allIssueForm = 'allIssueForm',

  allIssueWorkflows = 'allIssueWorkflows',

  createdWorkflow = 'createdWorkflow',
  updatedWorkflow = 'updatedWorkflow',
  workflowError = 'workflowError',

  createdStage = 'createdStage',
  updatedStage = 'updatedStage',
  deletedStage = 'deletedStage',
  reorderedStage = 'reorderedStage',
  stageError = 'stageError',

  createdDecision = 'createdDecision',
  decisionError = 'decisionError',

  allProcesses = 'allProcesses',
  updatedProcess = 'updatedProcess',
  processError = 'processError',

  allVisibleFields = 'allVisibleFields',

  tokenPush = 'tokenPush',

  checklistSectionCreated = 'checklistSectionCreated',
  checklistSectionUpdated = 'checklistSectionUpdated',
  checklistSectionDeleted = 'checklistSectionDeleted',
  checklistSectionReordered = 'checklistSectionReordered',
  checklistSectionDocumentDeleted = 'checklistSectionDocumentDeleted',

  checklistAnswerCreated = 'checklistAnswerCreated',
  checklistAnswerUpdated = 'checklistAnswerUpdated',
  checklistAnswerDeleted = 'checklistAnswerDeleted',

}

export interface Message<T = any> {
  type: DomainMessagesTypes;
  data?: T;
  error?: any;
  uniqueId?: string;
  requestId?: string;
}

/** A pull of an entity failed; `hasAll` will not follow. */
export function isPullFailedMessage(event: Message): boolean {
  return event.type === DomainMessagesTypes.pullFailed;
}

export function isFailUploadedMessage(event: Message): boolean {
  return event.type === DomainMessagesTypes.failUploadedEntity;
}

export function isUploadedMessage(event: Message): boolean {
  return event.type === DomainMessagesTypes.uploadedEntity;
}

export function isCreatedMessage(event: Message): boolean {
  return event.type === DomainMessagesTypes.createdEntity;
}

export function isCreateOrUpdate(event: Message): boolean {
  return (
    isCreatedMessage(event) ||
    event.type === DomainMessagesTypes.updatedEntity
  );
}

export function isUploadOrUpdate(event: Message): boolean {
  return (
    isUploadedMessage(event) ||
    event.type === DomainMessagesTypes.updatedEntity
  );
}

export function isDirectoriesBatchCreated(event: Message): boolean {
  return event.type === DomainMessagesTypes.directoriesBatchCreated;
}

export function isDataChanged(event: Message): boolean {
  return (
    isUploadedMessage(event) ||
    event.type === DomainMessagesTypes.updatedEntity ||
    event.type === DomainMessagesTypes.deletedEntity
  );
}

export function isDataAndTableUnchanged(event: Message): boolean {
  return (
    !(event.data && isDataChanged(event)) &&
    event.type !== DomainMessagesTypes.tableChanged
  );
}

